import { RESTAPIError } from './RESTAPIError'
import CLanguageHandler from '../../../Languages/LanguageHandler'
import { LanguageErrorCodes, LanguageErrors } from '../../../../../i18n'
import { EMPTY_STRING } from '../../../constants/Common'
import { IsStringEmpty } from '../../../utils/GlobalFunctions'
import { ServerError } from '../../Types/Types'
import { StatusCodes } from '../../../constants/StatusCodes'

export const handleErrorJSON = (e: ServerError, status: number = 0): RESTAPIError => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(LanguageErrorCodes.NAME)

    if (!IsStringEmpty(e.Message)) {
        return new RESTAPIError(status, e, e?.Message, EMPTY_STRING)
    }

    const errorMessageFromCode: string = language.get(
        (LanguageErrorCodes as unknown as Record<string, string>)[`Errorcode${e?.ErrorCode}`]
    )

    return new RESTAPIError(
        status,
        e,
        IsStringEmpty(errorMessageFromCode?.trim()) ? e?.ErrorMessage : errorMessageFromCode,
        e?.ErrorCode ? `${e?.ErrorCode}` : null,
        e?.Result
    )
}

export const handleError = async (response: Nullable<Response>): Promise<RESTAPIError> => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(LanguageErrors.NAME)

    if (!response) {
        return new RESTAPIError(0, null, language.get(LanguageErrors.UnknownError), '')
    }

    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const responseJSON: ServerError = await response.json()

        return handleErrorJSON(responseJSON, response.status)
    } catch (e) {
        return new RESTAPIError(
            response.status ?? StatusCodes.INTERNAL_SERVER_ERROR,
            null,
            IsStringEmpty(response.statusText) ? language.get(LanguageErrors.UnhandlableError) : response.statusText,
            null
        )
    }
}
